/* GASSISA
=========================================================================================
* Descripción: Menú lateral del sistema
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 23/11/2023 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 21/03/2026 | Lic. José Luis Aragón Cervantes  | Actualización a Box (flexbox)
*      3       | 21/03/2026 | Lic. José Luis Aragón Cervantes  | Cerrar grupos automáticamente
*      4       | 04/06/2026 | Lic. José Luis Aragón Cervantes  | Orden estable de grupos de menú
*      5       | 06/06/2026 | Lic. José Luis Aragón Cervantes  | Cerrar sesión visible en menú lateral
* ---------------------------------------------------------------------------------------
*/

import { Box, List, Typography, Button } from "@mui/material";
import { useSesion } from "../../context/System/SesionContext";
import { menuModuloIcons } from "../../settings/menuModel";
import { Fragment, useState } from "react";
import SizeSoftXMenuGroup from "./SizeSoftXMenuGroup";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

const SizeSoftXMenu = () => {
  const {
    definicionMenu,
    usuario,
    usuarioData,
    parametrosCajaForm,
    handleClickCerrarSesion,
  } = useSesion();

  const [openGroup, setOpenGroup] = useState(null);

  const handleToggleGroup = (groupKey) => {
    setOpenGroup(openGroup === groupKey ? null : groupKey);
  };

  const gruposVisibles = Object.keys(definicionMenu)
    .filter((clave_modulo) => clave_modulo !== "_paths" && definicionMenu[clave_modulo].mostrar)
    .sort((a, b) => {
      const menuA = definicionMenu[a] ?? {};
      const menuB = definicionMenu[b] ?? {};
      const orderA = menuA.orden != null ? Number(menuA.orden) : Number.MAX_SAFE_INTEGER;
      const orderB = menuB.orden != null ? Number(menuB.orden) : Number.MAX_SAFE_INTEGER;

      if (orderA !== orderB) return orderA - orderB;
      return (menuA.nombre ?? a).localeCompare(menuB.nombre ?? b);
    });

  return (
    <Fragment>
      <Box sx={{ 
        backgroundColor: "white", 
        paddingTop: 2, 
        paddingBottom: 2,
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        px: 1.5,
        overflow: "hidden",
      }}>
        <Typography
          variant="h2"
          sx={{
            color: "black",
            fontSize: "27px",
            width: "100%",
            textAlign: "center",
            lineHeight: 1.1,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {usuario}
        </Typography>
        <Typography
          variant="h3"
          sx={{
            color: "blue",
            fontSize: "12px",
            width: "100%",
            textAlign: "center",
            lineHeight: 1.35,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {usuarioData.Nombre}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: "gray",
            fontSize: "10px",
            width: "100%",
            textAlign: "center",
            lineHeight: 1.2,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {parametrosCajaForm?.caja || ""}
        </Typography>
        {parametrosCajaForm?.logo ? (
          <Box sx={{ mt: 1 }}>
            <img
              src={`data:image/png;base64,${parametrosCajaForm.logo}`}
              alt="Logo"
              style={{ width: "75px", height: "auto", border: "1px solid #ccc" }}
            />
          </Box>
        ) : null}
      </Box>
      <List
        sx={{
          width: "100%",
          overflowX: "hidden",
          boxSizing: "border-box",
          px: 0.75,
          py: 1,
        }}
      >
        {gruposVisibles.map((clave_modulo) => {
          const menu = definicionMenu[clave_modulo];
          return (
            <SizeSoftXMenuGroup
              key={clave_modulo}
              groupKey={clave_modulo}
              icon={menuModuloIcons[clave_modulo]}
              name={menu.nombre}
              clavesPaginas={menu["_paginas"]}
              isOpen={openGroup === clave_modulo}
              onToggle={() => handleToggleGroup(clave_modulo)}
            />
          );
        })}
      </List>
      <Box sx={{ 
        position: "sticky",
        bottom: 0,
        zIndex: 2,
        mt: 1, 
        mx: 1,
        mb: 1,
        pt: 0.75,
        pb: 0.5,
        backgroundColor: "inherit",
        borderTop: "1px solid rgba(255,255,255,0.22)",
      }}>
        <Button
          onClick={handleClickCerrarSesion}
          size="large"
          sx={{ width: "100%", color: "white" }}
          startIcon={<ExitToAppIcon />}
        >
          Cerrar sesión
        </Button>
      </Box>
    </Fragment>
  );
};

export default SizeSoftXMenu;
